/**
 * 头像预览组件
 * 选择图片文件后即时更新预览图，兼容 Unpoly layer（modal）内的 DOM
 */
export class Avatar {
  constructor(private input: HTMLInputElement) {
    this.handleChange = this.handleChange.bind(this);
    input.addEventListener("change", this.handleChange);
  }

  /** 读取选中的文件并更新预览图 */
  private handleChange(): void {
    const file = this.input.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const preview = up.fragment.get("#avatar-preview", {
        layer: "current",
      }) as HTMLImageElement | undefined;
      if (preview && e.target?.result) {
        preview.src = e.target.result as string;
      }
    };
    reader.readAsDataURL(file);
  }

  /** 销毁组件，清理事件监听 */
  destroy(): void {
    this.input.removeEventListener("change", this.handleChange);
  }

  /** 注册 Unpoly 编译器 */
  static compiler(selector: string): void {
    up.compiler(selector, (element: Element) => {
      const preview = new Avatar(element as HTMLInputElement);
      return () => preview.destroy();
    });
  }
}
